import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
import { useBooking } from './BookingContext';
interface ReserveButtonProps {
  label?: string;
  className?: string;
}
/**
 * The shared RSVP call-to-action. Opens the booking popup. Uses the signature
 * neon pill treatment so every CTA across the page reads identically.
 */
export function ReserveButton({
  label = 'RESERVE YOUR SPOT',
  className = ''
}: ReserveButtonProps) {
  const {
    openBooking
  } = useBooking();
  return <Button onClick={openBooking} className={`rounded-full bg-transparent border border-bc-pink text-bc-bone text-base tracking-label uppercase bc-glow-box hover:bc-glow-box-soft transition-all bc-ease px-8 h-14 ${className}`} data-id="element-159">
      {label}
      <ArrowRight className="ml-2 w-5 h-5" strokeWidth={1.5} data-id="element-160" />
    </Button>;
}